export const imgixLoader = ({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) => {
  const params = new URLSearchParams({
    w: width.toString(),
    q: quality?.toString() || "75",
    auto: "format,compress",
  });

  return `${src}?${params.toString()}`;
};

export default imgixLoader;
